import { useEffect, useState } from "react";

export default function useDateGreeting() {
    const [currentDate, setCurrentDate] = useState(new Date());

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentDate(new Date());
        }, 60000); // updates every minute

        return () => clearInterval(interval);
    }, []);

    const hour = currentDate.getHours();

    const greeting =
        hour < 12
            ? "Good morning"
            : hour < 18
            ? "Good afternoon"
            : "Good evening";

    const formattedDate = currentDate.toLocaleDateString("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
    });

    return {
        currentDate,
        greeting,
        formattedDate,
    };
}